import type {
  AxiosRequestConfig,
  DefaultQueryError,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { apiRoutes } from './api-routes';
import { webviewHttpClient } from '@/app/[locale]/(m)/components/auth/webview-http-client';

export interface UploadRatingImageParams {
  order_code: string;
  image: File;
}

export interface UploadRatingImageResponse {
  image_url: string;
}

export const uploadRatingImageFn = async (
  token: string,
  params: UploadRatingImageParams,
  config: AxiosRequestConfig = {}
): Promise<UploadRatingImageResponse> => {
  const formData = new FormData();
  formData.append('image', params.image);

  const response = await webviewHttpClient.post<UploadRatingImageResponse>(
    apiRoutes.ahafood.web_view.add_rating_image(params.order_code),
    formData,
    {
      ...config,
      headers: {
        ...config.headers,
        Authorization: token ? `Bearer ${token}` : '',
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  return response.data;
};

export const useUploadRatingImage = (
  token: string,
  options?: UseMutationOptions<
    UploadRatingImageResponse,
    DefaultQueryError,
    UploadRatingImageParams
  >
) =>
  useMutation<
    UploadRatingImageResponse,
    DefaultQueryError,
    UploadRatingImageParams
  >({
    mutationFn: (params) => uploadRatingImageFn(token, params),
    ...options,
  });
